export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/7479edc1b648ef7fdd2821d5a4b11e3e.png";